import { Component, OnInit } from "@angular/core";
import { NavController } from "@ionic/angular";
import { Title } from "@angular/platform-browser";
import { IncomeWealthService } from "./../../service/income-wealth.service";
import { DefaultPageComponent } from "../../../shared/page/default-page.component";
import { BackNativeService } from "../../../shared/service/comunicator-native/back-native/back-native";
import { JourneyService } from "../../../shared/service/journey/journey.service";
import { ReturnNativeService } from "../../../shared/service/comunicator-native/return-native/return-native";
import { AnalycticsNativeService } from "../../../shared/service/comunicator-native/analytics-native/analyctics-native";
import { TrackTypes } from "../../../shared/service/journey/tracks/model/track-types";
import { TrackInfo } from "../../../shared/service/journey/tracks/model/track-info";
import { AddressService } from "../../../address/services/address.service";
import { AnalyticsPageModel } from "../../../shared/model/analyticsPage";
import { AnalyticsPageService } from "../../../shared/service/analytics/analytics-page.service";
import { AnalyticsGA4PageService } from "../../../shared/service/analytics-ga4-pages/analytics-ga4-page.service";
import { AnalyticsGA4PagesModel } from "../../../shared/service/analytics-ga4-pages/analytics-ga4-pages-models";

@Component({
  selector: "app-income",
  templateUrl: "./income.page.html",
  styleUrls: ["./income.page.scss"],
})
export class IncomePageComponent
  extends DefaultPageComponent
  implements OnInit
{
  headerId = "income-wealthincome";
  titlePage = "Renda e patrimônio";
  label = "Renda e patrimônio";
  placeholder = "R$ 0,00";
  inputTextValue = "";
  startStage = "";
  endStage = "";
  analyticsPage: AnalyticsPageModel;
  analyticsPageGA4: AnalyticsGA4PagesModel;
  idLabelIncome = "labelIncome";
  idMessageIncome = "messageIncome";
  idInputCurrencyIncome = "inputCurrencyIncome";
  idButtonIncome = "buttonIncome";

  constructor(
    public backNativeService: BackNativeService,
    public journeyService: JourneyService,
    public router: NavController,
    public incomeWealthService: IncomeWealthService,
    private addressService: AddressService,
    private title: Title,
    public returnNativeService: ReturnNativeService,
    public analycticsNativeService: AnalycticsNativeService,
    private analyticsPageService: AnalyticsPageService,
    private analyticsGA4PageService: AnalyticsGA4PageService
  ) {
    super(backNativeService, journeyService, router, returnNativeService);
    this.getAnalyticsPage();
    this.getAnalyticsPageGA4();
    this.getTrack();
  }

  ngOnInit() {
    this.setTitle();
    this.headerFocus();
    this.editFieldInvest("renda", "income", "income");
  }

  getAnalyticsPage() {
    this.analyticsPage = this.analyticsPageService.setAnalyticsPage();
  }

  getAnalyticsPageGA4() {
    this.analyticsPageGA4 = this.analyticsGA4PageService.setAnalyticsPageGA4();
  }

  getTrack() {
    const track = this.journeyService.selectedTrack;

    if (
      track.getName() === TrackTypes.BASIC ||
      track.getName() === TrackTypes.BASIC_V2 ||
      track.getName() === TrackTypes.CONTA_ION ||
      track.getName() === TrackTypes.CONTA_ION_INCOME
    ) {
      this.startStage = "1";
      this.endStage = "3";
    }
  }

  ionViewWillEnter() {
    this.headerFocus();
    this.setEditPageRegistratio();
    this.analyticsData();
    this.sendTrackGA4LoadPage();
  }

  ionViewDidLeave() {
    this.ariaHidden = true;
  }

  analyticsData() {
    const it_pagename = this.analyticsPage.income;
    this.analycticsNativeService.analyticsTrackStateCommunicator(it_pagename);
  }

  sendTrackGA4LoadPage() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameScreenView,
      custom_path: this.analyticsPageGA4.customPathRenda,
      implementation_team: this.analyticsPageGA4.implementationTeam,
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl);
  }

  setTitle() {
    this.title.setTitle(this.titlePage);
  }

  clickNext() {
    const id =
      this.journeyService.registratioJourney.data.professionalData.originIncome;
    const incomeRequired =
      this.journeyService.registratioJourney.data.professionalData
        .incomeRequired;
    const idNotProf = ["12230", "11841", "11834"];
    const filterId = idNotProf.find((x) => x === id);

    if (
      (this.journeyService.journey === TrackTypes.BASIC &&
        filterId &&
        this.incomeWealthService.valueInformedEmpty(this.inputTextValue)) ||
      (!this.journeyService.selectedTrack.isEventComunicator() &&
        !incomeRequired &&
        this.incomeWealthService.valueInformedEmpty(this.inputTextValue))
    ) {
      this.inputTextValue = "0,00";
      this.incomeWealthService.setCheckBoxIncome(true);
      this.incomeWealthService.setIncome(
        this.inputTextValue,
        this.journeyService.journey,
        this.journeyService.selectedTrack.isEventComunicator()
      );
      this.nextPage();
    } else if (
      (this.journeyService.journey === TrackTypes.BASIC &&
        !filterId &&
        this.incomeWealthService.valueInformedEmpty(this.inputTextValue)) ||
      (!this.journeyService.selectedTrack.isEventComunicator() &&
        incomeRequired &&
        this.incomeWealthService.valueInformedEmpty(this.inputTextValue)) ||
      (this.journeyService.journey === TrackTypes.CONTA_ION &&
        this.incomeWealthService.valueInformedEmpty(this.inputTextValue)) ||
      (this.journeyService.journey === TrackTypes.CONTA_ION_INCOME &&
        this.incomeWealthService.valueInformedEmpty(this.inputTextValue))
    ) {
      this.inputTextValue = "0,00";
      localStorage.setItem("titleInf", "a sua renda");
      localStorage.setItem("subTitleInf", "renda");
      this.incomeWealthService.setCheckBoxIncome(false);
      this.router.navigateForward(["error", "error-income"]);
    } else {
      if (this.inputTextValue === "") {
        this.inputTextValue = "0,00";
      }
      this.incomeWealthService.setIncome(
        this.inputTextValue,
        this.journeyService.journey,
        this.journeyService.selectedTrack.isEventComunicator()
      );
      this.nextPage();
    }
  }

  analyticsEventClique() {
    const it_eventcategory = "Clique";
    const it_complementary = {
      it_eventaction: this.analyticsPage.action,
      it_eventlabel: this.analyticsPage.back,
      it_pagename: this.analyticsPage.income,
    };
    this.analycticsNativeService.analyticsTrackActionCommunicator(
      it_eventcategory,
      it_complementary
    );
  }

  getPageId(): string {
    return this.headerId;
  }

  verifyStatusBtn() {
    return this.inputTextValueNoEmpty();
  }

  setInputTextValue($event: string) {
    this.inputTextValue = $event;
    this.incomeWealthService.setCheckBoxIncome(
      this.inputTextValue === "0,00" ? true : false
    );
  }

  inputTextValueNoEmpty() {
    return this.inputTextValue.length > 0;
  }

  submitForm($event: any) {
    $event.preventDefault();
    return false;
  }

  backPage() {
    this.analyticsEventClique();
    const hasStepAddress =
      this.journeyService.selectedTrack.track.findIndex(
        (page: TrackInfo) => page.pageId === "cep"
      ) > -1;
    const hasStepProfessional =
      this.journeyService.selectedTrack.track.findIndex(
        (page: TrackInfo) => page.pageId === "profession"
      ) > -1;
    const hasStepMaritalStatus =
      this.journeyService.selectedTrack.track.findIndex(
        (page: TrackInfo) => page.pageId === "marital-status"
      ) > -1;

    if (
      this.journeyService.journey === TrackTypes.BASIC_V2 ||
      this.journeyService.journey === TrackTypes.BASIC_INCOME_V2 ||
      this.journeyService.journey === TrackTypes.BASIC_PROFESSIONAL_V2 ||
      this.journeyService.journey === TrackTypes.UPDATE_INCOME ||
      this.journeyService.journey === TrackTypes.UPDATE_INCOME_CONTA_ION ||
      this.journeyService.journey === TrackTypes.UPDATE_PROFESSIONAL ||
      this.journeyService.journey === TrackTypes.BASIC ||
      this.journeyService.journey === TrackTypes.BASIC_INCOME
    ) {
      if (hasStepProfessional) {
        return this.backToProfessionalStep();
      }
      if (hasStepAddress) {
        if (this.journeyService.journey === TrackTypes.BASIC) {
          return this.backToAddressStep();
        } else {
          return this.back();
        }
      }
      if (hasStepMaritalStatus) {
        return this.backToMaritalStatusStep();
      }
      if (
        this.journeyService.journey === TrackTypes.BASIC_INCOME_V2 ||
        this.journeyService.journey === TrackTypes.UPDATE_INCOME ||
        this.journeyService.journey === TrackTypes.UPDATE_INCOME_CONTA_ION
      ) {
        this.incomeWealthService.resetDataIncomeWealth();
        return this.router.navigateForward(["data", "client-data"]);
      }

      this.back();
    } else {
      this.back();
    }
  }

  backToProfessionalStep() {
    const id =
      this.journeyService.registratioJourney.data.professionalData
        ?.originIncome;
    const idNotProf = [
      "11839",
      "11843",
      "11838",
      "11841",
      "11834",
      "11837",
      "12230",
      "11840",
    ];
    const idWithProf = [
      "11829",
      "11846",
      "11845",
      "11835",
      "11836",
      "11832",
      "12229",
      "11831",
      "11842",
      "11830",
    ];
    const filterId = idNotProf.find((x) => x === id);
    const filterIdProf = idWithProf.find((x) => x === id);

    if (filterId) {
      return this.router.navigateBack(["professional-data", "origin-income"]);
    }
    if (filterIdProf) {
      return this.router.navigateBack(["professional-data", "company-cnpj"]);
    }
    if (!filterIdProf) {
      return this.router.navigateBack(["professional-data", "profession"]);
    }
  }

  backToAddressStep() {
    if (!this.addressService.addressInitalPostCode?.city) {
      return this.router.navigateBack(["address", "city"]);
    }
    if (
      !this.addressService.addressInitalPostCode?.state &&
      this.addressService.addressInitalPostCode?.city
    ) {
      return this.router.navigateBack(["address", "state"]);
    }
    if (
      !this.addressService.addressInitalPostCode?.district &&
      this.addressService.addressInitalPostCode?.city &&
      this.addressService.addressInitalPostCode?.state
    ) {
      return this.router.navigateBack(["address", "district"]);
    }
    if (
      this.addressService.addressInitalPostCode?.district &&
      this.addressService.addressInitalPostCode?.city &&
      this.addressService.addressInitalPostCode?.state
    ) {
      return this.router.navigateBack(["address", "adjunt"]);
    }
  }

  backToMaritalStatusStep() {
    const id =
      this.journeyService.registratioJourney.data?.maritalStatus?.maritalStatus;
    const idConjuge = ["608", "612"];
    const filterId = idConjuge.find((x) => x === id);

    if (!filterId) {
      return this.router.navigateBack(["marital-status", "marital-status"]);
    } else {
      this.back();
    }
  }

  setEditPageRegistratio() {
    if (this.journeyService.registratioJourney.data.incomeEquity.income) {
      if (
        this.journeyService.registratioJourney.data.incomeEquity.noIncome ===
          true ||
        this.journeyService.registratioJourney.data.incomeEquity.income ===
          "0.00" ||
        this.journeyService.registratioJourney.data.incomeEquity.income ===
          "0,00" ||
        this.journeyService.registratioJourney.data.incomeEquity.income ===
          "00.00"
      ) {
        this.inputTextValue = "";
      } else {
        this.setInputTextValue(
          this.journeyService.registratioJourney.data.incomeEquity.income
        );
      }
    }
  }
}
